import { render } from "./SubscriptionRequired.vue?vue&type=template&id=13572f00&scoped=true"
import script from "./SubscriptionRequired.vue?vue&type=script&lang=js"
export * from "./SubscriptionRequired.vue?vue&type=script&lang=js"

import "./SubscriptionRequired.vue?vue&type=style&index=0&id=13572f00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13572f00"]])

export default __exports__